<form #createCategoryForm="ngForm" name="form">
  <div mat-dialog-content>
    <div class="form-row align-items-center overflow-hidden">
      <div class="col-3 my-1">
        <h6>Name</h6>
        <input class="form-control" placeholder="Category Name" name="name" #name="ngModel"
          [(ngModel)]="machineCategory.Name" required>
      </div>

      <div class="col-4 my-1">
        <h6>Description</h6>
        <input class="form-control" placeholder="Description" name="description" #description="ngModel"
          [(ngModel)]="machineCategory.Description">
      </div>

      <div class="col-2 my-1 align-self-start">
        <h6 class="mb-3">Color</h6>
        <ng-container color-picker>
          <app-color-picker [(color)]="machineCategory.Color" [position]="'left'" [isInputHidden]="true"
            [label]="null"></app-color-picker>
        </ng-container>
      </div>

      <div class="col-3 my-1 text-right align-self-end">
        <button mat-raised-button class="w-40" [mat-dialog-close]="false">Cancel</button>
        <button mat-raised-button class="ml-3 w-40 btn-green"
          [disabled]="!createCategoryForm.valid" (click)="save()">Save</button>
      </div>
    </div>
  </div>
</form>
